<template>
  <div>
    <grid 
      grid-id="documents-grid"
      :fields="fields" 
      :items="documents"
       :no-records= "'No associated records found'"
      :get-items-function="getRequiredDocuments"
      :indicator="getStatus" />
  </div>
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    Grid,
  },
  props: ['companyId'],
  data() {
    return {
      fields: [
        { key: 'statusCommand', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'friendlyName', label: 'Document Name', sortable: true },
        { key: 'version', label: 'Version', sortable: true },
        { key: 'dependentRoles', label: 'Dependent Role(s)', sortable: true },
        { key: 'requiredSigners', label: 'Required Signatures', sortable: true },
        { key: 'requiredSignerNames', label: 'Authorized Signer', sortable: true },
        { key: 'pendingData', label: 'Pending Data', sortable: false },
        { key: 'execute', label: 'Execute', sortable: false },
        { key: 'dateInitiated', label: 'Date Sent', sortable: false },
        { key: 'dateExecuted', label: 'Date Executed', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('documents', [
      'documents',
    ]),
  },
  watch: {
    companyId: {
      handler() {
        this.getDocuments(this.companyId);
      }
    }
  },
  methods: {
    ...mapActions('documents', [ 
      'getDocuments', 
    ]),
    async getRequiredDocuments() {
      await this.getDocuments(this.companyId);
    },
    getStatus(data) {
      return (data.item.dateExecuted != null) ?
        '<i class="grid-commands-icon-check fa fa-check fa-fw mr-2"></i>' 
      + '<i class="grid-commands-icon-search fa fa-search fa-fw mr-2"></i>' : '';
    }
  }
}
</script>
<style scoped>
 
</style>